// ANCHOR React
import { memo } from 'react';

// ANCHOR Base
import {
  ModalBody, ModalHeader, SIZE, ROLE,
} from 'baseui/modal';
import { LabelLarge } from 'baseui/typography';

// ANCHOR Models
import { CreateFormQuestionAnswerForm } from '@lyon/scoped-models/form/create/CreateFormQuestionAnswerForm';
import { useCreateFormQuestionAnswerModalVisibilityStateAndHide } from '@lyon/scoped-models/form/create/CreateFormQuestionAnswerModalVisibility';

// ANCHOR Components
import { Divider } from '@lyon/components/utils/Divider';
import { CloseModal } from '@lyon/components/utils/CloseModal';
import { LyonCreateFormQuestionAnswerName } from './LyonCreateFormQuestionAnswerName';
import { LyonCreateFormQuestionAnswerWeight } from './LyonCreateFormQuestionAnswerWeight';
// import { LyonCreateFormQuestionAnswerFeedback } from './LyonCreateFormQuestionAnswerFeedback';
import { LyonCreateFormQuestionAnswerSubmit } from './LyonCreateFormQuestionAnswerSubmit';

// ANCHOR Styles
import { MODAL } from './styles';
import { LyonCreateFormQuestionAnswerNotification } from './LyonCreateFormQuestionAnswerNotification';

interface IProps {
  formQuestionId: string;
  label?: string;
}

export const LyonCreateFormQuestionAnswer = memo((
  { formQuestionId, label }: IProps,
) => {
  const [state, hide] = useCreateFormQuestionAnswerModalVisibilityStateAndHide();

  return (
    <CloseModal
      isOpen={state}
      onClose={hide}
      size={SIZE.default}
      role={ROLE.dialog}
      overrides={MODAL}
      animate
      autoFocus
      closeable
    >
      <ModalHeader>
        <LabelLarge>
          {label ?? 'Add an Answer'}
        </LabelLarge>
        <Divider />
      </ModalHeader>
      <ModalBody>
        <CreateFormQuestionAnswerForm.Provider formQuestionId={formQuestionId}>
          <LyonCreateFormQuestionAnswerNotification />
          <LyonCreateFormQuestionAnswerName />
          <LyonCreateFormQuestionAnswerWeight />
          {/* <LyonCreateFormQuestionAnswerFeedback /> */}
          <LyonCreateFormQuestionAnswerSubmit />
        </CreateFormQuestionAnswerForm.Provider>
      </ModalBody>
    </CloseModal>
  );
});
